export default class HtmlUtils {

    static isLocalhost(): boolean {
        return window.location.hostname == "localhost"
            || window.location.hostname.indexOf("10.") > -1
            || window.location.hostname.indexOf("127.") > -1
            || window.location.hostname.indexOf("192.") > -1
            || window.location.hostname.indexOf("172.16.") > -1
            ;
    }

    static getDomain(url: string): string {
        return url ? (url.split('/')[2] || url.split('/')[0]).split(':')[0] : url;
    }

    static getFullLocation(): string {
        return window.location.protocol
            + "//"
            + window.location.hostname
            + (window.location.port ? ":" + window.location.port : "");
    }

    static getFullUrl(url: string): string {
        return url.startsWith("http") ? url : this.getFullLocation() + (url.startsWith("/") ? "" : "/") + url.trimStart();
    }

    static downloadUrl(url: string, filename?: string): void {
        var a = document.createElement("a");
        document.body.appendChild(a);

        a.href = url;
        a.setAttribute("download", filename || (new Date().getTime().toString()));

        var b = document.createEvent("MouseEvents");
        b.initEvent("click", false, true);
        a.dispatchEvent(b);

        document.body.removeChild(a);
    }

    static openUrlInNewWindow(
        url: string,
        windowName?: string,
        features?: {
            noopener?: boolean;
            noreferrer?: boolean;
            forceNewWindow?: boolean;
        }
    ): Window | null {

        if (window.opener && features?.forceNewWindow !== true) {

            // Se já está em uma página secundária,
            // mantém a URL na mesma página se for algum 'viewer'.
            var aux = document.location.pathname.toLowerCase().split('/');
            if (aux.length > 3 && aux[2].endsWith('viewer')) {
                document.location.href = url;
                return window;
            }
        }

        var f: Array<string> = [];
        if (features?.forceNewWindow) f = ["location=0", "menubar=true", "resizable=true", "scrollbars=true", "status=true", "toolbar=false", "height=600", "width=800"];
        if (features?.noopener == true) f.push("noopener=true");
        if (features?.noreferrer == true) f.push("noreferrer=true");

        return window.open(this.getFullUrl(url), windowName, f.join(","));
    }

    static openCdsPlayer(
        parameters: string,
        windowName?: string,
        maximize?: boolean,
        width?: number | null,
        height?: number | null
    ): Window | null {

        var f: Array<string> = [];
        f.push("toolbar=no");
        f.push("menubar=no");

        if (width || height || maximize)
            f.push("resizable=no");

        if (maximize === true) {
            f.push(`width=${window.screen.availWidth}px`);
            f.push(`height=${window.screen.availHeight}px`);
            f.push("top=0");
        }
        else {
            if (width) f.push(`width=${width}`);
            if (height) f.push(`height=${height}`);
            if (width && height) {
                // Centraliza
                f.push(`left=${(window.screen.availWidth - width) / 2}`);
                f.push(`top=${(window.screen.availHeight - height) / 2}`);
            }
        }

        return window.open(this.getFullLocation() + "/cds?" + parameters, windowName, f.join(","));
    }

    static closeWindow(window: Window): void {
        return window.close();
    }

    static isHtml(str: string): boolean {
        return /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(str);
    }

    static escape(str: string): string {
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    static checkMouseInsideHtmlElement(element: HTMLElement, m: MouseEvent): boolean {
        const dropdown = element.getBoundingClientRect();
        const target = { y: m.clientY, x: m.clientX };
        return target.y >= dropdown.top && target.y <= dropdown.bottom && target.x >= dropdown.left && target.x <= dropdown.right;
    }

    static textToHtml(text: string): string {
        if (text) {
            return text.replace(/\n/g, "<br/>");
        }
        return text;
    }

    static screenDimension() {
        var x, y;
        if (window.innerWidth) {
            x = window.innerWidth;
            y = window.innerHeight;
        } else {
            x = document.body.clientWidth;
            y = document.body.clientHeight;
        }

        return { width: x, height: y };
    }

    static isIPad(): boolean {
        const m = navigator.platform.match(/iPad/i);
        return m != null && m.length > 0;
    }

    static copyToClipboard(text: string) {
        return navigator.clipboard.writeText(text);
    }

    static openGoogleMaps(address: string, city: string, state: string) {
        const url = "https://www.google.com/maps/place/" + address + "," + city + "," + state;
        window.open(url, "");
    }

    static openGoogleMapsFromPlace(place: string) {
        const url = "https://www.google.com/maps/place/" + place;
        window.open(url, "");
    }

    static buildQueryString(obj: object) {
        return Object.entries(obj)
            .filter(([k, v]) => v != null)
            .map(([k, v]) => `${k}=${v}`)
            .join('&');
    }


    static downloadBlobFromPromise(promise: Promise<any>) {
        var filename = "";

        promise
            .then(response => {
                if (response) {
                    if (response.status == 204)
                        throw "Nenhum arquivo foi recebido.";

                    const disposition = response.headers['content-disposition'];
                    filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];
                    if (filename.toLowerCase().startsWith("utf-8''"))
                        filename = decodeURIComponent(filename.replace("utf-8''", ''));
                    else
                        filename = filename.replace(/['"]/g, '');
                    return response.data;
                }
                return null;
            })
            .then(blob => {
                if (blob != null) {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a); // append the element to the dom
                    a.click();
                    a.remove(); // afterwards, remove the element
                }
            });

        return promise;
    }

    // static downloadBlob(blob: Blob, filename?: string): void {
    //     const objectUrl = window.URL.createObjectURL(blob);
    //     const anchor = document.createElement("a");
    //     document.body.appendChild(anchor);
    //     anchor.href = objectUrl;
    //     anchor.download = filename || (new Date().getTime().toString());
    //     anchor.click();
    //     window.URL.revokeObjectURL(objectUrl);
    //     document.body.removeChild(anchor);
    // }

}

export type ScreenPoint = { x: number; y: number; };
